import { render, staticRenderFns } from "./employeeUserTraining.vue?vue&type=template&id=fed16e4e"
import script from "./employeeUserTraining.vue?vue&type=script&lang=js"
export * from "./employeeUserTraining.vue?vue&type=script&lang=js"
import style0 from "./employeeUserTraining.vue?vue&type=style&index=0&id=fed16e4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports